import React from "react";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import SortReport from "./SortReport";
import { Divider } from "@mui/material";

const ReportList = ({ report }) => {
  const { t } = useTranslation();
  return (
    <>
      <Card style={{ marginTop: "16px" }}>
        <CardContent>
          <Typography
            variant="h6"
            component="div"
            style={{
              fontSize: "1rem",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>{t("views.report_page.TITLE_NAME_REPORT")}</span>
            <span style={{ marginRight: "25px" }}>
              {t("views.report_page.SHOW_HIDE")}
            </span>
          </Typography>
          <SortReport category={report} />
        </CardContent>
      </Card>
    </>
  );
};
const WrapperGrid = styled(Grid)`
  margin-top: 20px;
  @media (max-width: 768px) {
    max-width: calc(100% - 12rem);
    overflow: auto;
  }
`;
export default ReportList;
